import imageDark from 'img/priorityDownload/PriorityDownloadDark.png';
import image from 'img/priorityDownload/PriorityDownloadLight.png';
import React, { useEffect, useState } from 'react';
import { priorityDownload } from 'reactApp/appHelpers/featuresHelpers/features/priorityDownload';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { useInterval } from 'reactApp/hooks/useInterval';
import { closeContextMenu } from 'reactApp/ui/ContextMenu/createContextMenuToolkit';
import { secundPluralAccusative } from 'reactApp/utils/pluralHelpers';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import styles from './PriorityDownloadModal.css';

export interface PriorityDownloadModalProps {
    onBuy(): void;
    onFinishStep(): void;
    onShow(): void;
}

export function PriorityDownloadModal({ onBuy, onFinishStep, onShow }: PriorityDownloadModalProps) {
    const [tick, setTick] = useState(priorityDownload.delaySec);

    useEffect(() => {
        // на случай, если показываем модалку из места, где нет обработчика на закрытие контекстного меню
        closeContextMenu();
        onShow();
    }, []);

    const { start, clear } = useInterval(
        () =>
            setTick((prev) => {
                if (prev === 1) {
                    onFinishStep();
                }
                return prev - 1;
            }),
        1000
    );

    const imageUrl = isDarkThemeModeEnabled() ? imageDark : image;
    const title = (
        <>
            Файлы готовятся к&nbsp;скачиванию&nbsp;&mdash; оно&nbsp;начнётся через {tick}&nbsp;{secundPluralAccusative(tick)}
        </>
    );
    const text = <>Ускорить можно с&nbsp;подпиской Mail Space: выберите любой тариф, и&nbsp;ждать не&nbsp;придётся</>;
    return (
        <WhatsNewDialog
            preventStackDimmer
            closeOnEscape={false}
            className={styles.root}
            textClassName={styles.text}
            imageUrl={imageUrl}
            title={title}
            text={text}
            primaryButtonText="Не хочу ждать"
            onShow={start}
            onClick={onBuy}
            onClose={clear}
            closable={false}
            buttonTheme="vk"
            dialogSize="tiny"
            qaId="priority-download-modal"
            isRebranding
        />
    );
}
